import React, { useEffect, useState } from "react";

// Redux
import { Link, useSearchParams } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

// import images
import profile from "../../assets/images/profile-img.png";

import withRouter from "Components/Common/withRouter";
import { createSelector } from "reselect";
import { resetPasswordThunk } from "slices/auth/resetpwd/thunk";
import { setAuthorization } from "../../helpers/api_helper";
import { logOutUser } from "../../helpers/dataBackend";
import LanguageDropdown from "Components/Common/LanguageDropdown";
import { useTranslation } from "react-i18next";

const ResetPassword = (props: any) => {
  const { t } = useTranslation();
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [searchParams] = useSearchParams();
  const [showError, setShowError] = useState(false);
  const tokenParam = searchParams.get("token");

  const dispatch: any = useDispatch();

  //meta title
  document.title = "Reset Password ";

  const selectProperties = createSelector(
    (state: any) => state.ResetPassword,
    (reset) => ({
      error: reset.error,
    })
  );

  const { error } = useSelector(selectProperties);

  // Form validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: "",
      repeat_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please Enter Your Password"),
      repeat_password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values: any) => {
      // Este de aca se encarga de redirigir al usuario al dashboard
      dispatch(resetPasswordThunk(values, tokenParam, props.router.navigate));
    },
  });

  const validateLocalStorage = () => {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    if (localStorage.getItem("authUser")) {
      logOutUser();
      localStorage.clear();
    }
  };

  useEffect(() => {
    validateLocalStorage();
    if (error) {
      console.log(error);
      setShowError(true);
    }
  }, [dispatch, error]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-9">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome to DitoBanx !</h5>
                        <p>
                          You are about to reset the password, so please enter a
                          new password
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div
                  style={{ position: "absolute", right: "10px", top: "10px" }}
                >
                  <LanguageDropdown />
                </div>
                <CardBody className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        // return false;
                      }}
                    >
                      {/* INICIO DE CONSTRASENA */}
                      <div className="mb-3">
                        <Label className="form-label">{t("Password")}</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={show1 ? "text" : "password"}
                            placeholder={t("Enter Password")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <button
                            onClick={() => setShow1(!show1)}
                            className="btn btn-light "
                            type="button"
                            id="password-addon"
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </button>
                        </div>
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      {/* INICIO DE CONTRASENA */}
                      <div className="mb-3">
                        <Label className="form-label">{t("Password")}</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            name="repeat_password"
                            value={validation.values.repeat_password || ""}
                            type={show2 ? "text" : "password"}
                            placeholder={t("Enter Password")}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.repeat_password &&
                              validation.errors.repeat_password
                                ? true
                                : false
                            }
                          />
                          <button
                            onClick={() => setShow2(!show2)}
                            className="btn btn-light "
                            type="button"
                            id="password-addon"
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </button>
                        </div>
                        {validation.touched.repeat_password &&
                        validation.errors.repeat_password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.repeat_password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      {showError ? (
                        <p style={{ color: "red" }}>{error}</p>
                      ) : null}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block "
                          type="submit"
                        >
                          {t("Reset Password")}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Don't have an account ?")}{" "}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    {t("Log in")}{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ResetPassword);
